import { render } from "./brand_disable.vue?vue&type=template&id=0f6f3231"
import script from "./brand_disable.vue?vue&type=script&lang=js"
export * from "./brand_disable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sunshine\\code\\zydt\\独立部署版\\ywym\\ydd-zht-api\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__